import format from 'date-fns/format';
export const inceptionDate = {
  compulsory: format(new Date(), 'YYYY-MM-DD'),
  arbitrary: format(new Date(), 'YYYY-MM-DD'),   
};

export const carProfile = {
  vehicleKind: 'M',
  carNo: {
    block1: "",
    block2: "",
    carType: ""
  },
  exFactoryDate: {
    year: "",
    month: ""
  },
  carLicenseDate: {
    year: "",
    month: "",
    day: ""
  },
  cc: "",
  brand: "",
  carStyle: "",
  engineNo: "",
  maxPassengers: "2"
};
export const autoNoticeData = {  
  isNative: true,
  autojob: '', 
  type: '' ,
  ispro:''
 
};